import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import React, { Fragment, useContext, useEffect, useState } from "react";
import TextInputField from "../../../components/editable/EditableField/fields/TextInputField";
import ErrorDialog from "../../../components/notifications/errorDialog/ErrorDialog";
import { api, CategoryType, Report } from "../../../logic/api";
import { SessionContext } from "../../../utility/useSession";
import propTypes from "prop-types";
import CategorySelector from "./CategorySelector";
import { useReleaseManagement, ReleaseFlag } from "../../../utility/feature-management";
import DataSourceSelector from "./DataSourceSelector";
import { useTranslation } from "react-i18next";

const ReportEdit: React.FunctionComponent<{
    report: Report;
    show: boolean;
    onClose: (didUpdate: boolean, name: string, category: string, dataSource?: string) => void;
}> = (props) => {

    const session = useContext(SessionContext);

    const updateReportApi = api.hooks.reports.update();
    const { t } = useTranslation();


    const [reportName, setReportName] = useState<string>(props.report.name || "");
    const [category, setCategory] = useState<string>(props.report.category.categoryName || "");
    const [dataSource, setDataSource] = useState<string>(props.report.dataSource || "");

    useEffect(() => {
        if (props.show == true) {
            setReportName(props.report.name || "");
          setCategory(props.report.category.categoryName || "");
                setDataSource(props.report.dataSource || "");
        }
    }, [props.show == true]);


    const confirmUpdateReport = async () => {
        if (reportName.length == 0) {
            return;
        }
        if (category.length == 0) {
            return;
        }

        updateReportApi.send(session.current.context, {
            ...props.report,
            query: "",
            category: category,
            name: reportName,
          dataSource: dataSource,
        }, (report) => {
            if (report == null) {
                return;
            }
            props.onClose(true, reportName, category, dataSource);
        });
    }

    return <Fragment>

        <Dialog
            open={props.show}
            keepMounted

            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle id="alert-dialog-slide-title">{t("reports.editReport")}</DialogTitle>
            <DialogContent>
                <div style={{ paddingTop: 10 }}>
                    <TextInputField label={t("reports.reportName")} value={reportName} onChange={(value) => {
                        setReportName(value);
                    }} />
                </div>
                <div style={{ paddingTop: 20 }}>

                    <CategorySelector label={t("reports.selectCategory")} type={CategoryType.reports} value={category} onChange={(value) => {
                        setCategory(value);
                    }}></CategorySelector>
                </div>

          <div style={{ paddingTop: 20 }}>
                    <DataSourceSelector label={t("reports.selectData")} value={dataSource} onChange={(value) => {
                        setDataSource(value);
                    }}></DataSourceSelector>
          </div>

            </DialogContent>
            <DialogActions>
                <Button onClick={() => {
                    props.onClose(false, reportName, category, dataSource);
                }} color="secondary">{t("general.cancel")}</Button>
          <Button disabled={reportName.length == 0 || category.length == 0 || dataSource.length == 0} onClick={() => confirmUpdateReport()} color="primary">{t("general.apply")}</Button>
            </DialogActions>
        </Dialog>
        <ErrorDialog err={updateReportApi.err}></ErrorDialog>

    </Fragment>;
}

ReportEdit.propTypes = {
    report: propTypes.any.isRequired,
    show: propTypes.bool.isRequired,
    onClose: propTypes.func.isRequired
}

export default ReportEdit;
